/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Collapse, Select } from 'antd';
import clsx from 'clsx';
import find from 'lodash/find';
import { useParams } from 'react-router-dom';

import { useTranslate } from '@api/hooks';
import { Button } from '@atoms';

import PageLanguageSelect from '../PageLanguageSelect';

import * as s from './styles.module.less';

const scheduleKey = 'language';

const ArticleLanguageSelects = ({ availableLanguages = [], setTranslateError, ...props }) => {
  const [visibleCollapse, setVisibleCollapse] = React.useState(false);
  const [selectFromValue, setSelectFromValue] = React.useState(availableLanguages?.[0]?.name);
  const [selectToValue, setSelectToValue] = React.useState(props.locale);
  const [translateMutation, translateQuery] = useTranslate({});
  const { id: articleId } = useParams();
  const translationFields = ['title', 'standFirst', 'seoTitle', 'seoDescription', 'body'];

  const decodeHtmlCharCodes = (str) => {
    if (!str) return '';
    return str.replace(/(&#(\d+);)/g, function (match, capture, charCode) {
      return String.fromCharCode(charCode);
    });
  };

  React.useEffect(() => {
    const translateError = translateQuery.status === 'error';
    if (translateError) {
      setTranslateError(translateQuery.error);
    }

    if (translateQuery.data) {
      const { form } = props;
      translateQuery.data.forEach((elem) => {
        const field = elem.field;
        form.setFieldsValue({ [field]: field === 'body' ? elem.text : decodeHtmlCharCodes(elem.text) });
      });
    }
  }, [props, setTranslateError, translateQuery.data, translateQuery.error, translateQuery.status]);

  const handleCollapseToggle = React.useCallback(
    (opened) => {
      const active = opened ? opened.includes(scheduleKey) : false;
      setVisibleCollapse(active);
    },
    [setVisibleCollapse],
  );

  const handleTranslate = () => {
    const selectedLanguage = find(availableLanguages, { name: selectFromValue });
    translateMutation({
      articleId,
      fromLanguage: selectedLanguage.code,
      toLanguage: selectToValue,
      fields: translationFields,
    });
  };

  const handlePageSelect = (_selectToValue) => {
    setSelectToValue(_selectToValue);
  };

  const handleSelectFromValue = (selectValue) => {
    setSelectFromValue(selectValue);
  };

  return (
    <div className={clsx(s.headerWrapper)}>
      <PageLanguageSelect {...props} wrapperStyles={{ marginTop: 0 }} onSelect={handlePageSelect} />

      <Collapse
        bordered={false}
        accordion
        expandIconPosition="right"
        activeKey={visibleCollapse ? [scheduleKey] : undefined}
        onChange={handleCollapseToggle}
        className={clsx(s.collapse, { [s.active]: visibleCollapse })}
      >
        <Collapse.Panel key={scheduleKey} header="Auto-translate" disabled={!availableLanguages.length}>
          <div className={clsx(s.collapseSelectWrapper)}>
            <div className={clsx(s.selectWrapper)}>
              <div className={clsx(s.selectText)}>From:</div>
              <Select value={selectFromValue} style={{ minWidth: 160, maxWidth: 160 }} onSelect={handleSelectFromValue}>
                {availableLanguages.map(({ name }, idx) => (
                  <Select.Option key={idx} value={name}>
                    {name}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div className={clsx(s.collapseWrapper)}>
              <Button loading={translateQuery.isLoading} onClick={handleTranslate}>
                GO
              </Button>
            </div>
          </div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
};

export default ArticleLanguageSelects;
